import { SEARCH_AND_MONITORING_CONFIG_KEY } from '../constants/SearchAndMonitoringConstants'

export const removeSearchAndMonitoringConfig = () => {
   localStorage.removeItem(SEARCH_AND_MONITORING_CONFIG_KEY)
}
